module.exports = __webpack_public_path__ + "img/c2.1d91fb1b.webp";